import ServiceOrdersFormManager from './service-orders-form.manager.js'

class ServiceOrdersDetailsManager extends ServiceOrdersFormManager {
  data
  constructor (data) {
    super(data)
    this.data = data
  }

  historyAdapter () {
    return {
      activationCode: this.data?.activation_code,
      createdAt: this.data?.created_at,
      installedAt: this.data?.installed_at,
      uninstalledAt: this.data?.uninstalled_at,
      updatedAt: this.data?.requested_terminal?.updated_at,
      reallocatedFrom: this.data?.reallocated_from,
      reallocatedTo: this.data?.reallocated_to,
      trackingCode: this.data?.tracking_code,
      technicianName: this.data?.technician_name
    }
  }
}

export default ServiceOrdersDetailsManager
